import BaseClient from '@/app/model/api/response/baseApiClient'

class GroupDeleteApi extends BaseClient {
  public doGroupDelete (id: string) {
    const path: string = '/v1/master/groups/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new GroupDeleteApi()
